import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonToolbar, Spinner, Card, CardBody } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { Field, Form } from 'react-final-form';
import PropTypes from 'prop-types';
import renderSelectField from '@/shared/components/form/Select';
import FormField from '@/shared/components/form/FormField';
import validate from './validate';
import {
  getCupom,
  createCupom,
  updateCupom,
  newCupom,
} from '@/redux/actions/cupomActions';
import { listaTipoDesconto } from '../../../utils/helpers';

const CupomForm = ({ isHorizontal, isAboveError, props }) => {
  const dispatch = useDispatch();
  const [isRedirect, setIsRedirect] = useState(false);
  const cupom = useSelector((state) => state.cupons.cupom);
  const isFetching = useSelector((state) => state.cupons.isFetching);
  const error = useSelector((state) => state.cupons.error);
  const { id } = props.match.params;
  const isAddMode = !id;

  useEffect(() => {
    if (!isAddMode) {
      dispatch(getCupom(id));
    } else {
      dispatch(newCupom());
    }
  }, [dispatch, id, isAddMode]);

  if (cupom) {
    cupom.tipoDescontoSelect = {
      value: cupom.tipoDesconto,
      label: cupom.tipoDesconto,
    };
  }

  const onSubmit = (data) => {
    const formData = {};
    const fields = Object.keys(data).map((key, i) => key);
    fields.map((item) => (formData[item] = data[item]));
    formData.tipoDesconto = data.tipoDescontoSelect.value;
    isAddMode
      ? dispatch(createCupom(formData))
      : dispatch(updateCupom(id, formData));
    setIsRedirect(true);
  };

  if (isRedirect && !isFetching && !error) {
    return <Redirect to="/cupons" />;
  }

  return (
    <Card>
      <CardBody>
        <div className="card__title">
          <h4 className="bold-text">{isAddMode ? 'Novo' : 'Editar'} Cupom</h4>
        </div>
        {isFetching && <Spinner className="table-fetch-spinner" />}
        {(cupom || isAddMode) && !isFetching && (
          <Form
            onSubmit={onSubmit}
            validate={validate}
            initialValues={isAddMode ? {} : cupom}
          >
            {({ handleSubmit, form: { reset, pristine, submitting } }) => (
              <form
                className={`form ${isHorizontal && 'form--horizontal'}`}
                onSubmit={handleSubmit}
              >
                <div className="form__form-group">
                  <span className="form__form-group-label">Código</span>
                  <div className="form__form-group-field">
                    <Field
                      name="codigo"
                      type="text"
                      component={FormField}
                      rules={{ required: 'Campo Obrigatório' }}
                      isAboveError={isAboveError}
                      placeholder="Código do Cupom"
                      maxlength="15"
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Valor</span>
                  <div className="form__form-group-field">
                    <Field
                      name="valorDesconto"
                      type="number"
                      component={FormField}
                      isAboveError={isAboveError}
                      placeholder="Valor Desconto"
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    Tipo de Desconto
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      name="tipoDescontoSelect"
                      component={renderSelectField}
                      placeholder="Percentual ou Valor Fixo"
                      type="text"
                      options={listaTipoDesconto}
                      isAboveError={isAboveError}
                    />
                  </div>
                </div>

                <ButtonToolbar className="form__button-toolbar">
                  <Button color="primary" type="submit">
                    Salvar
                  </Button>
                  <Button type="button" onClick={() => setIsRedirect(true)}>
                    Cancelar
                  </Button>
                </ButtonToolbar>
              </form>
            )}
          </Form>
        )}
      </CardBody>
    </Card>
  );
};

CupomForm.propTypes = {
  isHorizontal: PropTypes.bool,
  isAboveError: PropTypes.bool,
};

CupomForm.defaultProps = {
  isHorizontal: false,
  isAboveError: false,
};

export default CupomForm;
